import styled, { css, FlattenSimpleInterpolation } from 'styled-components';

import { Breakpoint, Color, FontWeight, InfoBoxTheme } from '../../enums';
import { StyledComponent } from '../../interfaces';
import { Markdown } from '../markdown/markdown.component';

import { ContainerProps, DescriptionProps, HeaderProps, SubheaderProps } from './infoBox.types';

const InfoBoxStyles: { [b in InfoBoxTheme]: FlattenSimpleInterpolation } = {
  [InfoBoxTheme.Black]: css`
    background-color: ${Color.Black};
  `,
  [InfoBoxTheme.Gray]: css`
    background-color: ${Color.Gray200};
  `,
  [InfoBoxTheme.Orange]: css`
    background-color: ${Color.Error500};
  `,
};

export const Container: StyledComponent<'div', ContainerProps> = styled.div<ContainerProps>`
  ${({ $theme }: ContainerProps): FlattenSimpleInterpolation => InfoBoxStyles[$theme]};
  max-width: 500px;
  width: 100%;
  padding: 24px;
  min-height: 354px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  & + & {
    margin-left: 10px;
  }

  @media ${Breakpoint.Tablet} {
    min-height: 420px;
  }

  @media ${Breakpoint.Mobile} {
    max-width: 100%;
    min-height: 232px;

    & + & {
      margin-left: 0;
      margin-top: 10px;
    }
  }

  @media ${Breakpoint.SmallMobile} {
    min-height: 298px;
  }
`;

export const HeadersContainer: StyledComponent<'div'> = styled.div``;

export const Header: StyledComponent<'h3', HeaderProps> = styled.h3<HeaderProps>`
  font-size: 22px;
  line-height: 28px;
  font-weight: ${FontWeight.Medium};
  letter-spacing: -0.01em;
  color: ${({ $theme }: HeaderProps): string => $theme === InfoBoxTheme.Gray ? Color.Black : Color.White};
  margin-bottom: 8px;
`;

export const Subheader: StyledComponent<'p', SubheaderProps> = styled.p<SubheaderProps>`
  font-size: 12px;
  line-height: 16px;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  font-weight: ${FontWeight.Bold};
  color: ${({ $theme }: SubheaderProps): string => $theme === InfoBoxTheme.Gray ? Color.Black : Color.White};
  margin-bottom: 8px;
`;

export const Description: StyledComponent<typeof Markdown, DescriptionProps> = styled(Markdown)<DescriptionProps>`
  font-size: 16px;
  line-height: 22px;
  font-weight: ${FontWeight.Light};
  color: ${({ $theme }: DescriptionProps): string => $theme === InfoBoxTheme.Gray ? Color.Black : Color.White};  
`;
